/**
 * Canonical firm-size enum. Values double as Zod enum members and as the
 * `value` of dxSelectBox options. Kept in fido-types so client + server
 * schemas + UI all reference the same source of truth.
 */
export const FIRM_SIZE_VALUES = ['1', '2-5', '6-20', '21-50', '50+'] as const;

export type FirmSize = (typeof FIRM_SIZE_VALUES)[number];

/**
 * UI-ready option list for dxSelectBox: `[{ value: '1', text: '1' }, …]`.
 * `text` is currently identical to `value` (the enum strings are already
 * display-friendly) but is split as a separate field so display labels can
 * change later without touching the enum.
 */
export const FIRM_SIZE_OPTIONS: readonly { value: FirmSize; text: string }[] = FIRM_SIZE_VALUES.map(
  (value) => ({ value, text: value }),
);
